import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IParticipant } from "../../utils/types/models";

export default createEntityReducer<IParticipant>(Endpoint.Participants, Endpoint.ParticipantsList);
